export var helpCenterAccountApiRelativePath = '/account';
export var createHelpCenterAccountApi = function (baseUrl, http) {
    var helpCenterApiUrl = "" + baseUrl + helpCenterAccountApiRelativePath + "/helpCenter";
    var ticketingApiUrl = "" + baseUrl + helpCenterAccountApiRelativePath + "/helpCenterTicketsPage";
    return {
        isHelpCenterEnabled: function (dto) {
            return http.get(helpCenterApiUrl + "?id=" + dto.id);
        },
        enableHelpCenter: function (dto) {
            return http.post(helpCenterApiUrl + "/enable", dto);
        },
        disableHelpCenter: function (dto) {
            return http.post(helpCenterApiUrl + "/disable", dto);
        },
        isTicketingEnabled: function (dto) {
            return http.get(ticketingApiUrl + "?id=" + dto.brandId);
        },
        enableTicketing: function (dto) {
            return http.post(ticketingApiUrl + "/enable", dto);
        },
        disableTicketing: function (dto) {
            return http.post(ticketingApiUrl + "/disable", dto);
        },
    };
};
//# sourceMappingURL=index.js.map